<template>
  <div id="box">
    <!-- 未配置支付方式提示框 -->
    <a-divider v-if="!appId">请选择应用APPID</a-divider>
    <a-divider v-else-if="noConfigText">您尚未配置任何支付方式</a-divider>
    <!--      <a-divider v-else></a-divider>-->

    <!-- 支付测试面板 v-if=""-->
    <div v-if="payTestShow()" class="paydemo" style="width: 100%">
      <div class="paydemo-type-content">
        <div v-show="showTitle('WX')" class="paydemo-type-name article-title">
          微信支付
        </div>
        <div class="paydemo-type-body">
          <div
              v-show="appPaywayList.indexOf('WX_NATIVE') >= 0"
              :class="{ this: currentWayCode === 'WX_NATIVE' }"
              class="paydemo-type color-change"
              @click="changeCurrentWayCode('WX_NATIVE', 'codeImgUrl')"
          >
            <img
                class="paydemo-type-img"
                src="@/assets/payTestImg/wx_native.svg"
            /><span class="color-change">微信二维码</span>
          </div>

          <div
              v-show="appPaywayList.indexOf('WX_BAR') >= 0"
              :class="{ this: currentWayCode === 'WX_BAR' }"
              class="paydemo-type color-change"
              @click="changeCurrentWayCode('WX_BAR', '')"
          >
            <img
                class="paydemo-type-img"
                src="@/assets/payTestImg/wx_bar.svg"
            /><span class="color-change">微信条码</span>
          </div>

          <div
              v-show="appPaywayList.indexOf('WX_JSAPI') >= 0"
              :class="{ this: currentWayCode === 'WX_JSAPI' }"
              class="paydemo-type color-change"
              @click="changeCurrentWayCode('WX_JSAPI', 'codeImgUrl')"
          >
            <img
                class="paydemo-type-img"
                src="@/assets/payTestImg/wx_jsapi.svg"
            /><span class="color-change">公众号/小程序</span>
          </div>

          <div
              v-show="appPaywayList.indexOf('WX_H5') >= 0"
              :class="{ this: currentWayCode === 'WX_H5' }"
              class="paydemo-type-h5"
              @click="changeCurrentWayCode('WX_H5', 'payurl')"
          >
            <img
                class="paydemo-type-img"
                src="@/assets/payTestImg/wx_h5.svg"
            /><span class="color-change">微信H5</span>
          </div>
        </div>
      </div>
    </div>

    <Header></Header>

    <Menulist></Menulist>

    <div class="box_info">
      <div class="box_info_bottomlist" >
        <!-- 延期类型切换 -->
        <el-radio-group class="filter-tabs" v-model="radio1" @change="handleRadioChange">
          <el-radio-button :label="1">网卡延期</el-radio-button>
          <el-radio-button :label="3">终端延期</el-radio-button>
        </el-radio-group>

        <!-- 网卡状态筛选 -->
        <el-radio-group class="filter-chips" v-model="listQuery.inners" @change="handleRadioinner" v-if="radio1 == 1">
          <el-radio :label="1">正常</el-radio>
          <el-radio :label="2">过期</el-radio>
        </el-radio-group>

        <!-- 搜索条件与操作 -->
        <div class="filter-fields">
          <el-select class="filter-select" v-if="roles" v-model="listQuery.company" placeholder="请选择单位名称" @change="handleCompanyChange" filterable clearable>
            <el-option v-for="item in companylist" :key="item.company" :label="item.company" :value="item.company"></el-option>
          </el-select>

          <el-input class="filter-input" v-if="radio1 == 1" v-model="listQuery.iccid" placeholder="请输入需要搜索ICCID号码" clearable/>
          <el-input class="filter-input" v-if="radio1 == 3" v-model="listQuery.sn" placeholder="请输入需要搜索SN" clearable/>

          <el-button class="filter-btn filter-btn--primary" @click="handleSearch()">搜索</el-button>
          <el-button class="filter-btn filter-btn--warning" v-if="radio1 == 1 && roles" @click="handleSearchs()">导入模板</el-button>
          <el-button class="filter-btn filter-btn--plain" v-if="listQuery.iccids != '' && radio1 == 1 && roles" @click="clickkong()">重置</el-button>
        </div>

        <!-- 勾选记录后出现的批量操作 -->
        <el-button class="filter-btn filter-btn--primary filter-submit" v-if="vallists.length != 0" @click="handlePay">确认延期</el-button>
      </div>
<!--网卡-->
      <el-table
          :key="'tableKey'"
          :data="getlisdatas"
          border
          fit
          highlight-current-row
          style="width: 100%"
          stripe
          @selection-change="selectionChangeHandlerOrder"
          :header-cell-style="{  background:'#ddd',color:'#000000'}"
          v-if="radio1 == 1"
      >
        <el-table-column type="selection" width="55" align="center" />

        <el-table-column label="使用单位" align="center">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" :content="row.ybdept" placement="top-start">
              <span>{{ row.ybdept }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column label="信用代码" width="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.yscode }}</span>
          </template>
        </el-table-column>

        <el-table-column label="卡号" width="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.iccid }}</span>
          </template>
        </el-table-column>

        <el-table-column label="医保SN" width="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.ybsn }}</span>
          </template>
        </el-table-column>

        <el-table-column label="设备SN" width="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.sn }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="联系人" width="90">
          <template slot-scope="{ row }">
            <span>{{ row.uname }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="联系电话" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.uphone }}</span>
          </template>
        </el-table-column>


        <el-table-column align="center" label="服务到期时间" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.endtime }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="到期天数" width="80">
          <template slot-scope="{ row }">
            <span style="color: red;font-weight: bold">{{ getDaysDifference(row.endtime) == 0 ? '已过期':getDaysDifference(row.endtime) }}</span>
          </template>
        </el-table-column>
        <!--  这块需要管理员权限     -->
        <el-table-column align="center" class-name="small-padding" label="操作" width="150" >
          <template slot-scope="{ row, $index }">
            <el-button plain size="mini" type="warning" @click="chakanLook(row,2)">
              查看
            </el-button>
            <el-button plain size="mini" type="success" @click="onpay(row)">
              延期
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="display: flex;justify-content: flex-end;background: #fff">
        <pagination v-if="radio1 == 1 && total > 0" :limit.sync="listQuery.pagesize" :page.sync="listQuery.page" :total="total" @pagination="getlist"/>
      </div>

<!--终端-->
      <el-table
          :key="'tableKey'"
          :data="getlissdatas"
          border
          fit
          highlight-current-row
          style="width: 100%"
          stripe
          @selection-change="selectionChangeHandlerOrders"
          :header-cell-style="{  background:'#ddd',color:'#000000'}"
          v-if="radio1 == 3"
      >
        <el-table-column type="selection" width="55" align="center" />

        <el-table-column label="终端名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.title }}</span>
          </template>
        </el-table-column>

        <el-table-column label="型号" width="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.model }}</span>
          </template>
        </el-table-column>

        <el-table-column label="终端医保SN" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.ybsn }}</span>
          </template>
        </el-table-column>

        <el-table-column label="终端设备SN"  align="center">
          <template slot-scope="{ row }">
            <span>{{ row.sn }}</span>
          </template>
        </el-table-column>

        <el-table-column label="使用单位"  align="center">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" :content="row.ybdept" placement="top-start">
              <span>{{ row.ybdept }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column align="center" label="联系人" width="90">
          <template slot-scope="{ row }">
            <span>{{ row.uname }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="联系电话" width="130">
          <template slot-scope="{ row }">
            <span>{{ row.uphone }}</span>
          </template>
        </el-table-column>


        <el-table-column align="center" label="服务到期时间" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.endtime }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="到期天数" width="80">
          <template slot-scope="{ row }">
            <span style="color: red;font-weight: bold">{{ getDaysDifference(row.endtime) == 0 ? '已过期':getDaysDifference(row.endtime) }}</span>
          </template>
        </el-table-column>


        <!--  这块需要管理员权限     -->
        <el-table-column align="center" class-name="small-padding" label="操作" width="150" >
          <template slot-scope="{ row, $index }">
            <el-button plain size="mini" type="warning" @click="chakanLook(row,2)">
              查看
            </el-button>
            <el-button plain size="mini" type="success" @click="onpay(row)">
              延期
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex;justify-content: flex-end;background: #fff">
        <pagination v-if="radio1 == 3 && total > 0" :limit.sync="listQuery.pagesize" :page.sync="listQuery.page" :total="total" @pagination="getlists"/>
      </div>
    </div>


    <!-- 二维码弹窗 -->
    <pay-test-modal
        ref="payTestModal"
        @closeBarCode="$refs.payTestBarCode.visible = false"
    ></pay-test-modal>

    <!-- 条码弹框 -->
    <pay-test-bar-code
        ref="payTestBarCode"
        @CodeAgainChange="testCodeChange"
        @barCodeValue="barCodeChange"
    ></pay-test-bar-code>


    <el-dialog title="确认支付" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
      <div style="line-height: 30px;padding-bottom:30px;box-sizing: border-box;"><b style="color:#F56C6C;">注：特殊订单不支持退款，敬请理解！</b></div>
      <el-row :gutter="20">
        <el-col :span="8" v-for="(item,index) in dispriceidList" :key="index">
          <div class="grid-content" :class="item.id == currentPayId ? 'active':''" @click="handlePayId(item)">
            <div class="grid-content_time">{{item.count}}年</div>
            <div class="grid-content_zhifu">￥ <b style="font-size: 24px;color:#f84c4c;">{{ item.discount * priceList[0].price * item.count}}</b></div>
            <div class="grid-content_zhekou">{{ item.discountTitle }}</div>
            <div class="grid-content_daymoney">每日 {{ Math.round((item.discount * priceList[0].price / 365)*100)/100 }} 元</div>

            <span class="grid-content-label" v-if="item.id == currentPayId && item.count == 3">超高性价比</span>
          </div>
        </el-col>
      </el-row>

      <div class="box_radiolist">
        <div class="radiolist_title">选择支付方式</div>
        <div class="radiolist_content">
          <el-radio-group v-model="ruleForm.paymethod" size="mini" >
            <el-radio :label="1" border>线上支付</el-radio>
            <el-radio :label="2" border>线下付款</el-radio>
          </el-radio-group>
        </div>
      </div>

      <div class="box_radiolist" style="margin-bottom:0px;">
        <div class="radiolist_title">
         合计： <b style="color:#f84c4c;">{{ Total + addprice}} 元</b>
<!--          <div class="tooltip_icon" style="position: relative;" v-if="radio1 == 1 && listQuery.inners == 2">-->
<!--            ?-->
<!--            <div class="box_span">-->
<!--              <div style="text-align: left">卡延期费用：{{ Total }}元</div>-->
<!--              <div style="text-align: left">欠费：{{ addprice }}元<i></i></div>-->
<!--              <div style="text-align: left">合计：{{ Total+ addprice }}元</div>-->
<!--              <div style="text-align: left;color: #999;font-weight: normal;font-size:10px;line-height:30px">该网卡已过期,欠费费用不参与套餐折扣。</div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="radiolist_content">
          <el-button @click="resetForm()">取消</el-button>
<!--          <el-checkbox v-model="isAgree" style="margin-right: 15px;">我已阅读并同意<a href="javascript:;" style="color: #f00;font-weight: bold;cursor: pointer" @click.stop="boglook"> 服务协议</a></el-checkbox>-->
          <el-button type="primary"  @click="submitForm()">立即支付</el-button>
        </div>
      </div>

    </el-dialog>

    <!-- 服务协议弹窗 -->
<!--    <el-dialog title="服务协议" :visible.sync="visible" width="70%" custom-class="contract-dialog" :close-on-click-modal="false">-->
<!--      <contract :Fathertoson="Fathertoson"></contract>-->
<!--    </el-dialog>-->

    <el-dialog title="网卡详情" :visible.sync="dialogVisibleDetails_card" width="45%" custom-class="detail-dialog">
      <el-divider content-position="center">使用单位信息</el-divider>
      <el-card class="box-card">
        <!-- 单位名称通常很长，单独占整行，避免在窄列里折行 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="box_list">
              <div class="box_list_title">单位名称：</div>
              <div class="box_list_content">{{orderinfo.ybdept}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">信用代码：</div>
              <div class="box_list_content">{{orderinfo.yscode}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">联系人：</div>
              <div class="box_list_content">{{orderinfo.uname}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">联系方式：</div>
              <div class="box_list_content">{{orderinfo.uphone}}</div>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-divider content-position="center">网卡信息</el-divider>
      <el-card class="box-card">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">资费方式：</div>
              <div class="box_list_content">包年</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">运营商：</div>
              <div class="box_list_content">{{ orderinfo.yys }}</div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">设备SN：</div>
              <div class="box_list_content">{{orderinfo.sn}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">医保SN：</div>
              <div class="box_list_content">{{orderinfo.ybsn}}</div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">ICCID：</div>
              <div class="box_list_content">{{orderinfo.iccid}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">到期时间：</div>
              <div class="box_list_content">{{orderinfo.endtime}}</div>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <span slot="footer" class="dialog-footer detail-footer">
        <el-button @click="dialogVisibleDetails_card = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleDetails_card = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="终端详情" :visible.sync="dialogVisibleDetails_terminal" width="45%" custom-class="detail-dialog">
      <el-divider content-position="center">使用单位信息</el-divider>
      <el-card class="box-card">
        <!-- 使用单位通常很长，单独占整行 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="box_list">
              <div class="box_list_title">使用单位：</div>
              <div class="box_list_content">{{orderinfo.ybdept}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">信用代码：</div>
              <div class="box_list_content">{{orderinfo.yscode}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">联系人：</div>
              <div class="box_list_content">{{orderinfo.uname}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">联系方式：</div>
              <div class="box_list_content">{{orderinfo.uphone}}</div>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <el-divider content-position="center">终端信息</el-divider>
      <el-card class="box-card">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">终端名称：</div>
              <div class="box_list_content">{{ orderinfo.title }}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">终端型号：</div>
              <div class="box_list_content">{{ orderinfo.model }}</div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">终端设备SN：</div>
              <div class="box_list_content">{{orderinfo.sn}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">终端医保SN：</div>
              <div class="box_list_content">{{orderinfo.ybsn}}</div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">生产厂家：</div>
              <div class="box_list_content">{{orderinfo.manufacturer}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">服务到期时间：</div>
              <div class="box_list_content">{{orderinfo.endtime}}</div>
            </div>
          </el-col>
        </el-row>
      </el-card>



      <span slot="footer" class="dialog-footer detail-footer">
        <el-button @click="dialogVisibleDetails_terminal = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleDetails_terminal = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="Corporateaccount" width="30%" :close-on-click-modal="false" :close-on-press-escape="false">
      <div slot="title" style="font-weight: bold">下单成功！<span style="color: red;">订单待支付</span></div>
      <div class="prompt">恭喜您，下单成功！请支付成功后在个人中心上传支付凭证，以便完成后续延期服务。以下信息为对公账号信息，请截图保存妥善保管。</div>

      <el-divider content-position="center" style="margin: 20px 0;">对公账户信息</el-divider>

      <div class="box_account">
        <div class="box_account_title">名称</div><!--UnitName-->
        <div class="box_account_content">{{ configdata.UnitName }}</div>
      </div>

      <div class="box_account">
        <div class="box_account_title">税号</div><!--TaxID-->
        <div class="box_account_content">{{ configdata.TaxID }}</div>
      </div>

      <div class="box_account">
        <div class="box_account_title">开户银行</div><!--Bankofdeposit-->
        <div class="box_account_content">{{ configdata.Bankofdeposit }}</div>
      </div>

      <div class="box_account">
        <div class="box_account_title">银行账户</div><!--Bankaccount-->
        <div class="box_account_content">{{ configdata.Bankaccount }}</div>
      </div>

      <div class="box_account">
        <div class="box_account_title">付款金额</div>
        <div class="box_account_content" style="display:flex;color: red;font-weight: bold;">
          {{ Total + addprice }} 元
<!--          <div class="tooltip_icon" style="position: relative;margin-top: 17px" v-if="radio1 == 1 && listQuery.inners == 2">-->
<!--            ?-->
<!--            <div class="box_span">-->
<!--              <div style="text-align: left">卡延期费用：{{ Total }}元</div>-->
<!--              <div style="text-align: left">欠费：{{ addprice }}元</div>-->
<!--              <div style="text-align: left">合计：{{ Total+ addprice }}元</div>-->
<!--              <div style="text-align: left;color: #999;font-weight: normal;font-size:10px;line-height:30px">该网卡已过期,欠费费用不参与套餐折扣。</div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="Corporateaccount = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导入表格查询" :visible.sync="multipleSearchsstatus" width="30%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="上传模板">
          <el-upload
              class="upload-demo"
              accept=".xlsx"
              :action="uploadurls"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-success="handleuploadSucces"
              :data="updatedata"
              multiple
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="fileList"
          >
            <el-button size="mini" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip" style="color: #999">
              只能上传为格式xlsx文件
              <b style="color: #409EFF;margin-left: 5px;cursor: pointer" @click="download_data()">下载导入模板</b>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="multipleSearchsstatus = false">取消</el-button>
      </span>
    </el-dialog>

    <a-modal
        :confirm-loading="confirmLoading"
        :destroyOnClose="true"
        :maskClosable="false"
        :visible="visible"
        :zIndex="10000"
        title="阅读条款"
        width="45%"
        @cancel="handleCancel"
    >
      <Contract :Fathertoson="Fathertoson"></Contract>
      <template #footer>
        <a-button :disabled="disabled" type="primary" @click="handleOk">{{ valiBtn }}</a-button>
      </template>
    </a-modal>

    <Footer></Footer>
  </div>
</template>

<script>
import {
  getInfo,
  mail_send,
  mallOrderdata_apply_refund,
  mallOrderdata_deal_seal_list,
  mallOrderdata_getrestnum,
  order_orderlist,
  order_paywaitpay,
  cardPrice_priceList,
  order_paycard,
  terminal_expiring_terminals,
  card_expiring_cards, conf_list, card_getUseCompany
} from '@/api/manage' // 接口
import {Carousel} from 'ant-design-vue'
import PayTestModal from "./PayModal"; // 二维码对话框组件
import Pagination from '@/components/Pagination'
import Header from "@/components/heard/index.vue";
import Footer from "@/components/footer/index.vue";
import {getToken, removeToken} from "@/utils/auth";
import img from "@/assets/shili.png";
import jianceimg from "@/assets/key_images.png";
import PayTestBarCode from "@/views/seal/PayBarCode.vue";
import Menulist from "@/components/menulist/index.vue";
import Contract from "@/components/contract/contract.vue";
import {forEach} from "core-js/stable/dom-collections";

export default {
  name: 'paytest',
  props: {},
  components: {Menulist, PayTestModal, PayTestBarCode, Carousel, Pagination, Header, Footer, Contract},
  data() {
    return {
      uploadurls: 'prod/card/importiccid',
      Corporateaccount:false,
      priceList: [],
      dispriceidList:[],
      Fathertoson: {
        companyname: '',
        companyyscode: '',
        sendmethod: null,
        totalnum: '',
        jiezhiprice: '',
        guanzhuangprice: '',
        shengxinprice: '',
        year: ''
      },
      ruleForm: {
        appid:'card_shengtang',
        dispriceid:'',
        priceid:'',
        totalnum:1,
        paymethod:1,
        company:'',
        yscode:'',
        name:'',
        phone:'',
        email:'',
        iccids:'',
        iccidss:'',
        optype:"pc",
        ordertype:5,
        paystatus:1,
      },
      rules: {
        priceid: [
          { required: true, message: '请选择套餐', trigger: 'change' },
        ],
        dispriceid: [
          { required: true, message: '请选择折扣', trigger: 'change' },
        ],
        totalnum: [
          { required: true, message: '请选择购买年限', trigger: 'change' },
        ],
        paymethod: [
          { required: true, message: '请选择支付方式', trigger: 'change' },
        ],
        company: [
          { required: true, message: '请输入单位名称', trigger: 'blur' },
        ],
        yscode: [
          { required: true, message: '请输入信用代码', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' },
        ],
      },
      companyinfostatus:true,
      jianceimg:jianceimg,
      current: ["ukey"],
      sssvisiblesss: true,
      visiblemodd: false,
      // urlop:'images/93750.png',
      totalnum: 1,
      checked1: false,
      form: this.$form.createForm(this, {name: "coordinated"}),
      dialogStyle: {
        top: "40%",
      },
      dialogVisiblesss: false,
      phone: '',
      expressno:'',
      phonelist:[],
      Downloadstatus:false,
      headers: { Authorization: "Bearer " + localStorage.getItem("setToken") ,appid:CONFIG.appid},
      updatedata: {  uploadtype: "document",id:''},
      orderinfo:'',
      fileList: [],
      fileLists: [],
      dialogVisibleDetails_card:false,
      dialogVisibleDetails_terminal:false,
      nowcompany: '',
      nowemail: '',
      listLoading: false,
      textarea: '',
      yscode: '',
      dialogVisible:false,
      isAgree:false,
      visible:false,
      Fathertoson: {
        companyname: '',
        companyyscode: '',
        sendmethod: null,
        totalnum: null,
        jiezhiprice: '',
        guanzhuangprice: '',
        shengxinprice: '',
        year: 1,
      },
      sdisableds: false,
      timer: 60,
      mailbox: '',
      mailboxcode: '',
      getlisdatas: [],
      getlissdatas: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0
      },
      pattern: '/^\\w+((-\\w+)|(\\.\\w+))*@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$/',
      imgurl: require('@/assets/images/key.png'),
      imgbg: require('@/assets/images/topbg.jpeg'),
      mchAppList: [], // app列表
      appId: '2021003131636388', // 已选择的appId
      appPaywayList: ['ALI_QR'], // 商户app支持的支付方式
      currentWayCode: 'ALI_QR', // 以何种方式进行支付，默认是微信二维码
      currentPayDataType: '', // 支付参数
      mchOrderNo: '', // 模拟商户订单号
      authCode: '', // 条码的值
      companyyscode: '',
      paytestAmount: '0.01', // 支付金额，默认为0.01
      amountInput: false, // 自定金额输入框是否展示
      noConfigText: false, // 尚无任何配置分割线提示文字
      divisionMode: 0, // 订单分账模式
      orderTitle: '接口调试', // 订单标题
      value: 1,
      checked: false,
      checkeddef: true,
      sendmethod: 1,
      valuests: null,
      outtime: null,
      disabledlook: false,
      activities:[],
      visibletongzhi: false,
      visiblelook: false,
      valueaw: 2,
      valiBtn: '同意条款',
      ModalText: '阅读协议，哈哈首科大厦大家安康',
      visible: false,
      disabled: false,
      companyname: '',
      confirmLoading: false,
      radioStyle: {
        cursor: 'pointer',
        marginleft: '10px',
        height: '30px',
        lineHeight: '30px',
        color: '#132b75',
      },
      page: 1,
      pagesize: 10,
      mpd: null,
      vshow: true,
      isshowFooter: false,
      tobonumber: null,
      tobonum: null,
      Byyouji: null,
      number: {
        value: 11,
      },
      ID:'',
      year: null,
      month: null,
      dates: null,
      btnTime: null,
      projectname: '',
      xmalimg: '',
      usbkeyimg: '',
      maile: '',
      companytitle: '',
      notice: '',
      imgurlas: '',
      refunddata: {},
      configdata: {},
      orderid:'',
      OrderType:'',
      vallist:[],
      vallists:[],
      radio1:1,
      Total:0.00,
      listQuery:{
        orgcode:'',
        userid:'',
        company:'',
        iccid:'',
        iccids:'',
        sn:'',
        status:2,
        pagesize:10,
        page:1,
        inner:1,
        inners:1,
        expired:'',
        year:'',
        month:'',
        yscode:'',
      },
      discount:1,
      addprice:0,
      priceListthree:[],
      priceListone:[],
      paystatusnumber:true,
      roles:false,
      companylist:[],
      currentPayId:'',
      userInfostatus:false,
      listQuerys:{
        pagesize:10,
        page:1,
        yscode:'',
      },
      total:0,
      multipleSearchsstatus:false,
    }
  },
  created() {
    getInfo({}).then(response => {
      localStorage.setItem('yscode',response.user.userName);
      this.userid = response.user.userId
      this.orgcode = response.user.orgcode
      if((response.user.phonenumber == '' || response.user.phonenumber == null) ||(response.user.yscode == '' || response.user.yscode == null) || (response.user.company == '' || response.user.company == null) ||(response.user.email == '' || response.user.email == null) || (response.user.nickName == null || response.user.nickName == "")){
        this.userInfostatus = false
        this.$alert('请完善开票信息，补全再进行下一步！', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.push('/userinfo');
          }
        });
      }else{
        this.userInfostatus = true
      }
    })
    // 配置项目
    var that = this
    const yscode = localStorage.getItem('yscode');
    this.listQuery.yscode = yscode
    this.listQuery.userid =  this.userid
    this.zhekou()
    conf_list({page:1,pagesize:100,appid:"card_shengtang"}).then((response) => {
      // console.log(response.data,'配置项')
      this.configdata = response.data
      this.listQuery.year = ''
      this.listQuery.month = response.data.month +''
      this.getlist()
    });

    getInfo({}).then(response => {
      this.roles = response.roles[0] == 'agent'? true : false
      if(response.roles[0] == 'agent'){
        card_getUseCompany({}).then(response => {
          // console.log(response.data,'公司信息')
          this.companylist = response.data
        })
      }
      var priceLists = JSON.parse(response.user.price)
      var priceListone = []
      var priceListthree = []
      for (let i = 0; i < priceLists.length; i++) {
        if(priceLists[i].type == 1){ // 套餐
          priceListone.push(priceLists[i])
          this.ruleForm.priceid = priceLists[i].id
          this.priceListone = priceListone
        }else if(priceLists[i].type == 3){ // 终端
          priceListthree.push(priceLists[i])
          this.priceListthree = priceListthree
          this.ruleForm.priceid = priceLists[i].id
        }
      }
      this.priceList = this.radio1 == 1? priceListone:priceListthree
      setTimeout(function() {
        that.zhekou()
      }, 1000);
      // 信息
      this.yscode = response.user.userName
      this.userid = response.user.userId
      this.ruleForm.company = response.user.company
      this.ruleForm.yscode = response.user.userName
      this.ruleForm.name = response.user.nickName
      this.ruleForm.phone = response.user.phonenumber
      this.ruleForm.email = response.user.email
      this.listQuery.yscode = response.user.userName
      this.nowcompany = response.user.userName
      this.companyinfo = response.user
    })
  },
  methods: {
    zhekou(){
      //套餐折扣 调试用 dispriceidList
      cardPrice_priceList({type:4,pagesize:20,page:1}).then(response => {
        // console.log(response.data.data,'dispriceidList11111')
        this.dispriceidList = response.data.data
        this.currentPayId = response.data.data[0].id
        this.ruleForm.dispriceid = response.data.data[0].id
        this.ruleForm.totalnum = response.data.data[0].count *1
        this.discount = response.data.data[0].discount
        // this.settlement()
      })
    },
    getDaysDifference(dateStr) {
      const now = new Date(); // 当前时间
      const eventDate = new Date(dateStr); // 事件时间
      if(now > eventDate){
        const diffDays = 0
        return diffDays;
      }else{
        const diffTime = Math.abs(now - eventDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // 转换为天数
        return diffDays+'天';
      }
    },
    selectionChangeHandlerOrder(val) {
      this.vallists = []
      if (val.length !== 0) {
        for (let i = 0; i < val.length; i++) {
          this.vallists.push(val[i].iccid)
        }
      }
    },
    selectionChangeHandlerOrders(val) {
      this.vallists = []
      if (val.length !== 0) {
        for (let i = 0; i < val.length; i++) {
          this.vallists.push(val[i].sn)
        }
      }
      console.log(this.vallists,'vallists')
    },
    handleRadioChange(e){
      this.radio1 = e
      if(e == 1){
        this.getlist()
        this.ruleForm.priceid = this.priceListone[0].id
        this.listQuery.sn == ''
        this.zhekou()
        // this.settlement()
      }else{
        this.getlists()
        this.ruleForm.priceid = this.priceListthree[0].id
        this.listQuery.iccid == ''
        this.zhekou()
        // this.settlement()
      }
    },

    // 下载模板信息
    download_data() {
      window.location.href = '/xlx/network.xlsx'
    },
    handleuploadSucces(res,file) {
      this.listQuery.iccids = res.data
      this.page = 1
      this.getlist()
      this.multipleSearchsstatus = false
      this.kong()
    },

    handleChange(value) {
      console.log(value)
    },
    handlePreview(file) {
      console.log(file)
    },
    handleRemove(file, fileList) {
      this.fileList = []
      this.cardData = []
      // console.log(file, fileList)
    },
    handleRadioinner(e){
      var that = this
      if(e == 1){
        that.listQuery.inners = e
        that.listQuery.inner = ''
        that.listQuery.expired = ''
        that.listQuery.year = ''
        that.listQuery.month = that.configdata.month +''
        this.getlist()
        this.zhekou()
      }else if(e == 2){
        that.listQuery.inners = e
        that.listQuery.inner = ''
        that.listQuery.expired = 1
        that.listQuery.year = that.configdata.year +''
        that.listQuery.month = that.configdata.month +''
        this.getlist()
        this.zhekou()
      }
    },
    boglook() {
      this.visible = true
    },
    handleSearchs(){
      this.fileList = []
      this.fileLists =  []
      this.multipleSearchsstatus = true
    },

    submitForm(formName) {
      var that = this
      if (
          !this.$refs.payTestBarCode.getVisible() &&
          (this.currentWayCode === "WX_BAR" ||
              this.currentWayCode === "ALI_BAR" ||
              this.currentWayCode === "AUTO_BAR")
      ) {
        this.$refs.payTestBarCode.showModal();
        return;
      }
      // console.log(that.radio1,'that.radio1')
      console.log(that.ruleForm.iccidss,'iccidss')
      that.ruleForm.ordertype = that.radio1 == 1? 5:6
      that.ruleForm.iccids = that.zhuangtaidanshuang == true ?that.vallists.join(','):that.ruleForm.iccidss//that.radio1 == 1? that.ruleForm.iccidss:that.vallists.join(',')
      that.ruleForm.userid = that.companyinfo.userId
      that.ruleForm.paystatus = that.radio1 == 1? that.listQuery.inners:1,
      order_paycard(that.ruleForm).then(response => {
        // console.log(response)
        if(this.ruleForm.paymethod == 1){
          that.$refs.payTestModal.showModal(this.currentWayCode, response.data); // 打开弹窗
          that.randomOrderNo(); // 刷新订单号
          that.getlist()
          that.dialogVisible = false
          this.getInfo()
        }else{
          that.getlist()
          that.Corporateaccount = true
          that.dialogVisible = false
          that.getInfo()
        }
      })
    },

    resetForm(formName) {
      this.dialogVisible = false
    },
    kong(){
      this.page = 1
      this.ruleForm = {
        fileList: [],
        fileLists: [],
        appid:'card_shengtang',
        userid:'',
        priceid:'',
        totalnum:1,
        paymethod:1,
        paystatus:1,
        company:'',
        yscode:'',
        name:'',
        phone:'',
        iccids:'',
        iccidss:'',
        optype:"pc",
        ordertype:5,
        dispriceid:'',
        zhuangtaidanshuang:false,
      }
      if(this.radio1 == 1){
        this.getlist()
        return false
      }else{
        this.getlists()
      }
    },
    clickkong(){
      if(this.radio1 == 1){
        this.listQuery.iccids = ''
        this.page = 1
        this.getlist()
        return false
      }else{
        this.getlists()
      }
    },

    getlist() {
      this.listLoading = true
      this.listQuery.userid =  this.userid
      this.listQuery.orgcode =  this.orgcode
      card_expiring_cards(this.listQuery).then(response => {
        this.getlisdatas = response.data.data
        this.total = response.data.total
      })
      conf_list({appid:"card_shengtang"}).then((response) => {
        // console.log(response)
        var obj = response.data;
        obj = JSON.stringify(obj);
        localStorage.setItem('configdata', obj)
        this.configdata = response.data
      });
    },

    getlists() {
      this.listLoading = true
      this.listQuery.userid =  this.userid
      this.listQuery.yscode = this.yscode
      terminal_expiring_terminals(this.listQuery).then(response => {
        this.getlissdatas = response.data.data
        this.total = response.data.total
      })
    },


    handleClose(tab, event) {
      this.dialogVisible = false
      this.Total = '0.00'
      this.ruleForm.totalnum = 3
      this.isAgree = false
    },

    // 条码弹窗点击x或者蒙版关闭
    testCodeChange() {
      this.randomOrderNo(); // 刷新订单号
    },
    barCodeChange(value) {
      this.authCode = value;
      this.immediatelyPay();
    },
    // 刷新订单号
    randomOrderNo() {
      this.getlist()
      this.mchOrderNo =
          "M" +
          new Date().getTime() +
          Math.floor(Math.random() * (9999 - 1000) + 1000);
    },

    chakanLook(row,index){
      this.orderinfo = row
      if(this.radio1 == 1){
        this.dialogVisibleDetails_card = true
      }else if(this.radio1 == 3){
        // terminal_selectlist
        this.dialogVisibleDetails_terminal = true
      }
    },

    homepay() {
      this.$router.push('/');
    },
    payTestShow() {
      // 如果未选择appid，或者支付方式列表为0，则不显示支付体验板块
      if (this.appId === "" || this.appPaywayList.length === 0) {
        return false;
      } else {
        return true;
      }
    },
    // 此处判断，微信，支付宝，聚合码，哪种支付方式一个都没配置，如果未配置，则不显示该板块，若等于-1 则表示不存在
    showTitle(parameterA) {
      if (this.appPaywayList.toString().indexOf(parameterA) === -1) {
        return false;
      } else {
        return true;
      }
    },
    showModal(e) {
      // mallOrderdata/getrestnum
      mallOrderdata_getrestnum({id: e}).then(response => {
        this.refunddata = response.data
        this.Id = e
        this.textarea = ''
        this.visible = true;
      })
    },
    handleCancel(e) {
      this.textarea = ''
      this.visible = false;
    },
    handleOk(e) {
      this.visible = false
      this.isAgree = true
    },
    // 搜索
    handleSearch(){
      this.listQuery.page = 1
      if(this.radio1 == 1){
        this.listQuery.sn = ''
        this.getlist()
      }else {
        this.listQuery.iccid = ''
        this.getlists()
      }
    },



    // 切换商家
    handleCompanyChange(val){
      this.listQuery.company = val
      this.listQuery.page = 1
      this.getlist()
    },
    // 切换选择套餐
    handlePayId(val){
      // console.log(val,'val')
      this.currentPayId = val.id
      this.ruleForm.dispriceid = val.id
      this.ruleForm.totalnum =  val.count *1
      this.discount =  val.discount
      this.price =  this.priceList[0].price
      this.settlement()
    },
    //勾选支付
    handlePay(){
      if(this.userInfostatus == false){
        this.$alert('请完善开票信息，补全再进行下一步！', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.push('/userinfo');
          }
        });
        return false
      }else{
        this.userInfostatus = true
        this.zhuangtaidanshuang = true
        this.dialogVisible = true
        this.addprice = 0
        this.paystatusnumber = true
        var iccids = this.vallists.join(',')
        this.ruleForm.iccidss = iccids
        this.ruleForm.email =  this.companyinfo.email
        this.ruleForm.company = this.companyinfo.company
        this.ruleForm.name = this.companyinfo.userName
        this.ruleForm.phone = this.companyinfo.phonenumber
        this.ruleForm.yscode = this.companyinfo.yscode
        this.zhekou()
        this.priceList = this.radio1 == 1 ?this.priceListone:this.priceListthree
        if(this.radio1 == 1 && this.listQuery.inners == 2){
          var unitprice = (this.priceList[0].price * 1) / 12
          // this.addprice = (this.configdata.month * 1) * unitprice * this.vallists.length
        }else{
          this.addprice = 0
        }
        this.settlement()
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择1个文件`)
    },
    // 单个支付
    onpay(row){
      if(this.userInfostatus == false){
        this.$alert('请完善开票信息，补全再进行下一步！', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.push('/userinfo');
          }
        });
        return false
      }else {
        this.userInfostatus = true
        this.zhuangtaidanshuang = false
        // console.log(row,'row')
        this.dialogVisible = true
        this.addprice = 0
        this.paystatusnumber = false
        this.ruleForm.iccidss = this.radio1 == 1 ? row.iccid : row.sn
        this.ruleForm.email =  this.companyinfo.email
        this.ruleForm.company = this.companyinfo.company
        this.ruleForm.name = this.companyinfo.userName
        this.ruleForm.phone = this.companyinfo.phonenumber
        this.ruleForm.yscode = this.companyinfo.yscode
        this.zhekou()
        this.priceList = this.radio1 == 1 ? this.priceListone : this.priceListthree
        if (this.radio1 == 1 && this.listQuery.inners == 2) {
          var unitprice = (this.priceList[0].price * 1) / 12
          // this.addprice = (this.configdata.month * 1) * unitprice * 1
        } else {
          this.addprice = 0
        }
        this.settlement()
      }
    },
    // 结算价格
    settlement(){
      this.price =  this.priceList[0].price
      var paynumber = this.paystatusnumber == true ?this.vallists.length:1
      var number = this.price * this.ruleForm.totalnum * paynumber * this.discount
      this.Total = Math.floor(number * 100) / 100;
    },

  }
}
</script>

<style lang="css" scoped>
@import './payTest.css';

b {
  color: #333;
}
#box {
  display: block;
  width: 100%;
  overflow: hidden;
  background-image: url('../../assets/bg1.png');
  background-size: 100% 100%;
  background-position: center;
  background-attachment: fixed; /* 背景图片固定 */
  min-height: 100vh; /* 至少为视口高度 */
  padding-bottom:20px;
  box-sizing: border-box;
}

.financeitem{padding: 5px;border-bottom: #ccc dashed 1px;}
#leftbar {
  display: flex;
  flex-direction: row;
}

.ant-carousel >>> .slick-dots {
  height: auto;
}

.ant-carousel >>> .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 60%;
}

.ant-carousel >>> .slick-thumb {
  bottom: -45px;
}

.ant-carousel >>> .slick-thumb li {
  width: 60px;
  height: 45px;
}

.ant-carousel >>> .slick-thumb li img {
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

.ant-carousel >>> .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}

#ok .ant-form-item-label label::after {
  content: '';
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}

.displayssssss {
  display: flex;
  flex-direction: column;
  height: 100px;
  position: relative;
}

.displayssssss p {
  float: right;
  width: 300px;
  text-align: right;
  position: absolute;
  right: 0;
}

/*box_info*/

.box_info {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 30px 25px;
  box-sizing: border-box;

}

/* ===== 详情弹窗（网卡 / 终端）：字段行不再固定高度，长文本在自身列内换行 ===== */
.box_list{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  min-height: 38px;
  padding: 8px 0;
  box-sizing: border-box;
}

/*box_info_bottomlist —— 顶部搜索筛选栏*/
.box_info_bottomlist{
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin: 10px 0 16px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #F0F1F4;
  border-radius: 12px;
  box-sizing: border-box;
}

/* 延期类型：分段切换 */
.box_info_bottomlist ::v-deep .filter-tabs {
  display: inline-flex;
  padding: 3px;
  border-radius: 10px;
  background: #F5F6F8;
}

.box_info_bottomlist ::v-deep .filter-tabs .el-radio-button__inner {
  height: 32px;
  padding: 0 18px;
  line-height: 32px;
  font-size: 14px;
  color: #4E5969;
  background: transparent;
  border: none !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  transition: all 0.2s;
}

.box_info_bottomlist ::v-deep .filter-tabs .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff;
  background: linear-gradient(90deg, #E5453F 0%, #F0605C 100%);
  box-shadow: 0 2px 8px rgba(229, 69, 63, 0.28) !important;
}

/* 网卡状态筛选 */
.box_info_bottomlist ::v-deep .filter-chips {
  display: inline-flex;
  align-items: center;
}

.box_info_bottomlist ::v-deep .filter-chips .el-radio {
  margin-right: 0;
  margin-left: 12px;
}

.box_info_bottomlist ::v-deep .filter-chips .el-radio__label {
  padding-left: 6px;
  font-size: 14px;
  color: #4E5969;
}

.box_info_bottomlist ::v-deep .filter-chips .el-radio__input.is-checked .el-radio__inner {
  border-color: #E5453F;
  background: #E5453F;
}

.box_info_bottomlist ::v-deep .filter-chips .el-radio__input.is-checked + .el-radio__label {
  color: #E5453F;
  font-weight: bold;
}

/* 右侧搜索条件与操作，自动贴右 */
.filter-fields {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: auto;
}

.filter-select {
  width: 300px;
}

.filter-input {
  width: 240px;
}

/* 搜索栏内输入框 / 下拉框统一高度与圆角 */
.box_info_bottomlist ::v-deep .el-input__inner {
  height: 36px;
  line-height: 36px;
  border-radius: 8px;
  border: 1px solid #E6E8EB;
  color: #1D2129;
}

.box_info_bottomlist ::v-deep .el-input__inner:hover {
  border-color: #C9D3E0;
}

.box_info_bottomlist ::v-deep .el-input__inner:focus {
  border-color: #E5453F;
  box-shadow: 0 0 0 3px rgba(229, 69, 63, 0.1);
}

/* 按钮统一尺寸 */
.box_info_bottomlist .filter-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 20px;
  border-radius: 8px;
  font-size: 14px;
}

.filter-submit {
  margin-left: 6px;
}

.box_info_bottomlist .filter-btn--primary {
  border: none;
  color: #fff;
  background: linear-gradient(90deg, #E5453F 0%, #F0605C 100%);
  box-shadow: 0 4px 12px rgba(229, 69, 63, 0.22);
}

.box_info_bottomlist .filter-btn--primary:hover,
.box_info_bottomlist .filter-btn--primary:focus {
  color: #fff;
  background: linear-gradient(90deg, #CC3A34 0%, #E04F4A 100%);
  box-shadow: 0 6px 16px rgba(229, 69, 63, 0.3);
}

.box_info_bottomlist .filter-btn--plain {
  border: 1px solid #E6E8EB;
  color: #4E5969;
  background: #fff;
}

.box_info_bottomlist .filter-btn--plain:hover,
.box_info_bottomlist .filter-btn--plain:focus {
  border-color: #C9D3E0;
  background: #F7F8FA;
  color: #1D2129;
}

/* 导入模板：与表格里「查看」按钮同一个黄色（Element 警告色） */
.box_info_bottomlist .filter-btn--warning {
  border: 1px solid #F5DAB1;
  color: #E6A23C;
  background: #FDF6EC;
}

.box_info_bottomlist .filter-btn--warning:hover,
.box_info_bottomlist .filter-btn--warning:focus {
  border-color: #E6A23C;
  color: #E6A23C;
  background: #FBF0DF;
}

.prompt{
  display: block;
  /*/text-indent: 2em;/*/
  line-height: 50px;
  font-weight: bold;
  color: #67C23A;
  text-align: center;
}
.box_account{
  display: flex;
  height: 50px;
  line-height: 50px;
}
.box_account_title{
  display: block;
  width: 100px;
}

.el-radio__input.is-checked+.el-radio__label {
  color: red;

}


.tooltip_icon {
  display: inline-block;
  margin:2.5px 0 0 5px;
  width: 15px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  background: #999;
  color: #fff;
  border-radius: 50%;
  cursor: pointer;

}

  .box_span {
    display: none;
    width:250px;
    height: 100px;
    color: red;
    background: #fff;
    position: absolute;
    left: 10px;
    bottom: 30px;
    z-index: 9;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
  }

.tooltip_icon:hover .box_span{
  display: block !important;
}

.el-input__wrapper {

  border: 1px solid #eee;

  box-shadow: 0 0 0 0px #eee inset;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  border-radius: 4px;

  background: #FFF !important;

}


::v-deep  .el-input__inner{

  background: #FFF !important;
  height: 40px !important;
  font-size: 14px;
  font-weight: 400;
  color: #333;

}


.grid-content{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  margin: 0 auto;
  padding:30px 10px;
  box-sizing: border-box;
  border:3px solid #F56C6C;
  /* border-color:#dd9d59 */
  border-radius: 10px;
  background: #fff;
  color: #f84c4c;
  border-color: #ddd;
  cursor: pointer;
  position: relative;
  /* background:#fde2e2 */

}
.grid-content-label{
  display: block;
  height: 30px;
  line-height: 30px;
  padding: 0 15px;
  color: #fff;
  font-size: 14px;
  border-radius: 5px;
  background:linear-gradient(to right,#f36632,#fe9b3f);
  position: absolute;
  top: -17px;
  left: -2px;
  z-index: 9;
}

.active{
  border-color: #F56C6C;
  background: #fde2e2;
}
.grid-content_time{
  display: block;
  text-align: center;
  font-size: 20px;

}
.grid-content_zhifu{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  line-height: 50px;
  font-size: 22px;

}


.grid-content_zhekou{
  display: block;
  width: 100%;
  height: 30rpx;
  line-height: 30rpx;
  text-align: center;
  font-size: 14px;
  background: #F56C6C;
  color: #fff;
  border-radius: 5px;
  margin-bottom: 10px;

}

.grid-content_daymoney{
  font-size: 12px;
}

.box_radiolist{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}

.radiolist_title{
  font-weight: bold;

}


.radiolist_content{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

span{
  overflow:hidden; /*超出一行文字自动隐藏*/
  text-overflow:ellipsis;/*文字隐藏后添加省略号*/
  white-space:nowrap;  /*强制不换行*/
}
.box_list_title{
  flex: none;
  width: 92px;
  line-height: 22px;
  color: #86909C;
}

.box_list_content{
  flex: 1;
  min-width: 0;
  line-height: 22px;
  color: #1D2129;
  word-break: break-all;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

/* 弹窗头部 / 分节标题 / 卡片 / 底部按钮 */
::v-deep .detail-dialog {
  border-radius: 14px;
  overflow: hidden;
}

::v-deep .detail-dialog .el-dialog__header {
  padding: 18px 24px;
  border-bottom: 1px solid #F0F1F4;
}

::v-deep .detail-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: bold;
  color: #1D2129;
}

::v-deep .detail-dialog .el-dialog__headerbtn {
  top: 19px;
  right: 20px;
}

::v-deep .detail-dialog .el-dialog__body {
  padding: 6px 24px 4px;
  max-height: 62vh;
  overflow-y: auto;
}

::v-deep .detail-dialog .el-dialog__footer {
  padding: 0 24px 20px;
}

::v-deep .detail-dialog .el-divider--horizontal {
  margin: 14px 0 12px;
  background-color: #F0F1F4;
}

::v-deep .detail-dialog .el-divider__text {
  padding: 0 12px;
  font-size: 13px;
  font-weight: bold;
  color: #1D2129;
  background-color: #fff;
}

.box-card {
  border-color: #F0F1F4;
  border-radius: 10px;
  box-shadow: none;
}

.box-card ::v-deep .el-card__body {
  padding: 6px 20px;
}

.detail-footer .el-button {
  min-width: 88px;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
}

.detail-footer .el-button--default {
  border-color: #E6E8EB;
  color: #4E5969;
}

.detail-footer .el-button--default:hover,
.detail-footer .el-button--default:focus {
  border-color: #C9D3E0;
  background: #F7F8FA;
  color: #1D2129;
}

.detail-footer .el-button--primary {
  border: none;
  color: #fff;
  background: linear-gradient(90deg, #E5453F 0%, #F0605C 100%);
  box-shadow: 0 6px 14px rgba(229, 69, 63, 0.24);
}

.detail-footer .el-button--primary:hover,
.detail-footer .el-button--primary:focus {
  color: #fff;
  background: linear-gradient(90deg, #CC3A34 0%, #E04F4A 100%);
}

</style>

<!-- 服务协议弹窗全局样式（非scoped，作用于el-dialog内部） -->
<style>
.contract-dialog {
  margin-top: 5vh !important;
}
.contract-dialog .el-dialog__body {
  padding: 10px 20px 20px;
}
</style>
